module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "count-wrap greenstyle"
  }, [_c('div', {
    staticClass: "count-inner"
  }, [_c('div', {
    staticClass: "count-text"
  }, [_vm._v("一日所需能量")]), _vm._v(" "), _c('countTo', {
    staticClass: "count-num",
    attrs: {
      "separator": _vm.theseparator,
      "startVal": _vm.startVal,
      "endVal": _vm.endVal,
      "duration": 2000
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "count-text"
  }, [_vm._v("千卡")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dayneed-result"
  }, [_c('div', {
    staticClass: "result-text text-center"
  }, [_vm._v("各餐配比")]), _vm._v(" "), _c('div', {
    staticClass: "bili-wrap"
  }, [_c('div', {
    staticClass: "bili-block bili-a"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "bili-item bili1"
  }, [_c('span', [_vm._v(_vm._s(_vm.a * 2))]), _vm._v("千卡\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "bili-item bili2"
  }, [_c('span', [_vm._v(_vm._s(_vm.a * 2))]), _vm._v("千卡\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "bili-item bili3"
  }, [_c('span', [_vm._v(_vm._s(_vm.a))]), _vm._v("千卡\r\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "bili-info"
  }, [_vm._v("餐比A")])]), _vm._v(" "), _c('div', {
    staticClass: "bili-block bili-b"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "bili-item bili1"
  }, [_c('span', [_vm._v(_vm._s(_vm.b))]), _vm._v("千卡\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "bili-item bili2"
  }, [_c('span', [_vm._v(_vm._s(_vm.b))]), _vm._v("千卡\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "bili-item bili3"
  }, [_c('span', [_vm._v(_vm._s(_vm.b))]), _vm._v("千卡\r\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "bili-info"
  }, [_vm._v("餐比B")])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "calculate-link",
    attrs: {
      "to": "/dayneedindex"
    }
  }, [_vm._v("返回首页")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8729ce36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dayneed/dayneedresult.vue
// module id = 149
// module chunks = 1